export default __webpack_public_path__ + "static/media/bg3.fc6e78ce.png";